import '../css/style.css';
import '@fortawesome/fontawesome-free/js/all.js';
import { ImageSlider } from './ImageSlider.js';

new ImageSlider();
